<template>
  <div class="filters-row">
    <b-row class="mb-3" v-if="mobileVersion">
      <back-button withoutButton></back-button>
    </b-row>
    <div v-for="filter in baseSelectFilters" :key="filter"><base-select @search="handleSearch($event, filter)" searchable clearable :loading="filters[filter].loading" :options="filters[filter].options" valueProp="id" :label="filters[filter].label" v-model="filters[filter].value" @input="filters[filter].input" :placeholder="filters[filter].placeholder">
      <template v-if="filter === 'specialityOrName'" #option="data">
          <div v-if="isNumber(data.option.value)">
            <span>{{data.option.label}}</span>
          </div>
          <div v-else>
            <img class="photo-option" :src="getUserPhoto(data.option.value)" alt=""/> <span>{{data.option.label}}</span>
          </div>
        </template>
    </base-select><hr></div>
    <div class="text-center mt-4 mb-5"><base-button @click="search">{{$t('filters.showResults')}}</base-button></div>
    <b-row v-if="!mobileVersion">
      <back-button withoutButton></back-button>
    </b-row>
  </div>
</template>

<script>
import specialitiesRepository from '@/repositories/SpecialitiesRepository'
import searchRepository from '@/repositories/SearchRepository'
import subspecialitiesRepository from '@/repositories/SubspecialitiesRepository'
import healthServicesRepository from '@/repositories/HealthServicesRepository'
import geographyRepository from '@/repositories/GeographyRepository'
import languageRepository from '@/repositories/LanguageRepository'
import diseasesRepository from '@/repositories/DiseasesRepository'
import { PROFESSIONAL } from '@/constants/search'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker.vue'
import VueSlider from 'vue-slider-component'
import BackButton from '@/components/base/buttons/BackButton'
import { PROFESSIONAL_MALE_DEFAULT_IMAGE } from '@/constants/images'
import { getCurrencyByDomain } from '@/constants/currencies'
import { SCREEN_LG_GRID } from '@/constants/mediaQueries'
import { checkIgnoringNonRelevantCharactersFromOptionLabel } from '@/helpers/string.helpers'

export default {
  components: {
    BaseDatepicker,
    VueSlider,
    BackButton
  },
  data () {
    return {
      baseSelectFilters: ['specialityOrName', 'location', 'disease', 'language', 'subspeciality', 'service'],
      filters: {
        userType: {
          value: PROFESSIONAL,
          defaultValue: PROFESSIONAL
        }
      },
      specialty: {
        options: [],
        value: null
      },
      PROFESSIONAL
    }
  },
  created () {
    this.setFilters()
    this.loadFilters()
  },
  computed: {
    currency () {
      return getCurrencyByDomain()
    },
    mobileVersion () {
      return window.innerWidth < SCREEN_LG_GRID
    }
  },
  methods: {
    setFilters () {
      this.baseSelectFilters.forEach(filterName => {
        this.$set(this.filters, filterName, {
          loading: false,
          options: [],
          placeholder: this.$t(`filters.${filterName}`),
          value: null,
          label: 'name'
        })
      })
      this.filters.specialityOrName.input = this.specialityOrNameSelected
      this.filters.location.input = this.locationSelected
    },
    loadFilters () {
      this.loadSpecialties()
      this.loadCities()
      this.loadLanguages()
      this.loadSubspecialties()
      this.loadDiseases()
      this.loadServices()
    },
    isNumber (data) {
      return !isNaN(data)
    },
    handleSearch (event, filterKey) {
      if (filterKey === 'disease') {
        this.loadDiseases(event)
      } if (filterKey === 'specialityOrName') {
        this.searchUserByName(event)
      }
    },
    loadSpecialties () {
      specialitiesRepository['getProfSpecialitiesByCity'](this.filters.location.value).then(response => {
        let data = response.data.map(item => { return {id: item.id, name: this.$i18nHelpers.normalize(item.name)} })
        this.specialty.options = data
        this.filters.specialityOrName.options = data
      })
    },
    loadCities () {
      geographyRepository['getProfCitiesBySpecialty'](this.specialty.value).then(response => {
          this.filters.location.options = response.data
      })
    },
    loadLanguages () {
      languageRepository['getProfLanguagesBySpecialty'](this.specialty.value).then(response => {
          this.filters.language.options = response.data
      })
    },
    loadDiseases (search) {
      diseasesRepository['getProfDiseases'](search).then((response) => {
        this.filters.disease.options = response.data
        this.filters.disease.loading = false
      })
    },
    loadSubspecialties (search) {
      subspecialitiesRepository['getProfSubspecialities'](search, this.specialty.value).then((response) => {
          this.filters.subspeciality.options = response.data
          this.filters.subspeciality.loading = false
      })
    },
    loadServices (search) {
      healthServicesRepository['getProfHealthServicesByNameAndCity'](search, this.filters.location.value).then((response) => {
          this.filters.service.options = response.data
          this.filters.service.loading = false
      })
    },
    search () {
      let params = {}
      let emptyFilters = Object.keys(this.filters).every(key => {
        return this.filters[key].defaultValue ? this.filters[key].value === this.filters[key].defaultValue : !this.filters[key].value
      })
      if (emptyFilters) {
        this.$store.dispatch('showInfoAlert', this.$t('filters.selectFilter'))
        return
      }
      Object.keys(this.filters).filter(item => item !== 'specialityOrName').forEach(key => { params[key] = this.filters[key].value })
      params[this.isNumber(this.filters.specialityOrName.value) ? 'specialty' : 'userId'] = this.filters.specialityOrName.value
      this.$emit('search', params)
    },
    searchUserByName (name) {
      if (name && name.length >= 3) {
        searchRepository['getProfsByName'](name).then(response => {
          this.filters.specialityOrName.options = [...this.specialty.options, ...response.data.data]
        })
      }
    },
    specialityOrNameFilter (options, search) {
      if (search) {
        let result = []
        result.push(...options.filter(option => this.isNumber(option.value) && checkIgnoringNonRelevantCharactersFromOptionLabel(option, search) > -1))
        if (search.length >= 3) result.push(...options.filter(option => !this.isNumber(option.value)))
        return result
      } else {
        return this.specialty.options
      }
    },
    getUserPhoto (id) {
      let user = this.filters.specialityOrName.options.find(item => item.id === id)
      if (user.photo) {
        return user.photo
      } else {
        return PROFESSIONAL_MALE_DEFAULT_IMAGE
      }
    },
    specialityOrNameSelected () {
      if (this.isNumber(this.filters.specialityOrName.value)) {
        this.specialty.value = this.filters.specialityOrName.value
        this.loadLanguages()
        this.loadCities()
        this.loadSubspecialties()
        this.filters.subspeciality.value = null
        this.filters.subspeciality.options = []
      } else {
        this.search()
      }
    },
    locationSelected () {
      this.loadSpecialties()
    },
    removeFilters () {
      Object.keys(this.filters).forEach(key => { this.filters[key].value = this.filters[key].defaultValue ? this.filters[key].defaultValue : null })
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-row{
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
.red {
  color: $red;
}
.blue {
  color: $blue;
}
.pointer {
  cursor: pointer;
}
.prof-user-selector{
  margin-right: 1rem;
  @include screen-xl-grid-max {
    margin-right: 0;
  }
}
/deep/ .no-border-right{
  input{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
/deep/ .no-border-left{
  input{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
/deep/ .vue-slider-dot {
  background-color: $blue;
  border-radius: 50%;
}
.photo-option{
  border-radius: 100%;
  padding: 0;
  width: 30px;
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/professional/interconsultations/SearchFiltersProfessional.vue